import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VRow,
        { staticClass: "mt-0", attrs: { "no-gutters": "" } },
        [
          _c(VSpacer),
          _c(
            VCol,
            { attrs: { cols: "4" } },
            [
              _c(VSelect, {
                attrs: {
                  items: _vm.diagnosticos,
                  "item-text": "nome",
                  "item-value": "id",
                  label: "Diagnóstico:",
                  "return-object": "",
                },
                model: {
                  value: _vm.diagnostico,
                  callback: function ($$v) {
                    _vm.diagnostico = $$v
                  },
                  expression: "diagnostico",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { "no-gutters": "" } },
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c("v-card-widget", { attrs: { title: "Informações" } }, [
                _c(
                  "div",
                  { attrs: { slot: "widget-content" }, slot: "widget-content" },
                  [
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _c(VCol, { attrs: { cols: "6" } }, [
                          _c("span", { staticClass: "font-weight-bold" }, [
                            _vm._v("Diagnóstico: "),
                          ]),
                          _c("span", { staticClass: "font-weight-light" }, [
                            _vm._v(
                              _vm._s(
                                _vm.diagnostico.nome ? _vm.diagnostico.nome : ""
                              )
                            ),
                          ]),
                        ]),
                        _vm.inicio && _vm.fim
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Período: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm._f("date")(_vm.inicio)) +
                                    " até " +
                                    _vm._s(_vm._f("date")(_vm.fim))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { attrs: { "no-gutters": "" } },
                      [
                        _vm.unidade.id
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Unidade: "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(
                                  _vm._s(_vm.unidade.sigla) +
                                    " - " +
                                    _vm._s(_vm.unidade.nome)
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.avaliado !== ""
                          ? _c(VCol, { attrs: { cols: "6" } }, [
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v("Avaliado(a): "),
                              ]),
                              _c("span", { staticClass: "font-weight-light" }, [
                                _vm._v(_vm._s(_vm.avaliado)),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card-widget",
                { attrs: { title: _vm.titulo ? _vm.titulo : "Formulário" } },
                [
                  _vm.isDispensado
                    ? _c(
                        "div",
                        {
                          attrs: { slot: "widget-content" },
                          slot: "widget-content",
                        },
                        [
                          _c("info-dispensa", {
                            attrs: {
                              mensagem: `A participação no diagnóstico não está disponível. (${_vm.motivoDispensa})`,
                            },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          attrs: { slot: "widget-content" },
                          slot: "widget-content",
                        },
                        [
                          _c("AppTutorial", {
                            attrs: { tutorial: _vm.visibleTutorial },
                          }),
                          _vm.prazoEsgotado &&
                          _vm.usuarioMapeamento.tipo == "REGULAR"
                            ? _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(
                                        VCol,
                                        [
                                          _c("app-alert", {
                                            attrs: {
                                              icon: "watch_later",
                                              message:
                                                "O prazo para participação está esgotado. Obrigado pela sua colaboração.",
                                              type: "warning",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm.prazoFuturo &&
                              _vm.usuarioMapeamento.tipo == "REGULAR"
                            ? _c(
                                VRow,
                                { attrs: { "no-gutters": "" } },
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c("app-alert", {
                                        attrs: {
                                          icon: "watch_later",
                                          message:
                                            "O prazo para participação ainda não está disponível.",
                                          type: "info",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [_vm._t("body")],
                            2
                          ),
                        ],
                        1
                      ),
                  !_vm.prazoEsgotado && !_vm.prazoFuturo
                    ? _c(
                        "div",
                        {
                          attrs: { slot: "widget-actions" },
                          slot: "widget-actions",
                        },
                        [
                          _c(
                            VRow,
                            { attrs: { "no-gutters": "" } },
                            [
                              _c(
                                VCol,
                                { attrs: { cols: "12" } },
                                [_vm._t("actions")],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }